import type TTConfig from '../../../../cms/client/TTConfig';
import axios, { type AxiosInstance } from 'axios';
import type { RoseCardAPIResponseContract } from '../RoseCardContract';

const defaultConfig: TTConfig = {
    endpoint: 'https://3ta9e9wexi.execute-api.eu-west-1.amazonaws.com/v1/'
};

export class RoseAPIClient {

    private constructor(
        public readonly axiosInstance: AxiosInstance
    ) {}

    public static async build(config: TTConfig = defaultConfig): Promise<RoseAPIClient> {
        const instance: AxiosInstance = axios.create({
            baseURL: config.endpoint,
            ...(config.axiosConfig || {})
        });
        config.authProvider?.configure(instance);
        return new RoseAPIClient(instance);
    }

    /* Product API */
    public async productDetail(productId: string): Promise<{ data: RoseCardAPIResponseContract }> {
        return this.axiosInstance.get(`/product-detail/${productId}`);
    }
}
